import React from 'react';
import { X, Move, Replace } from 'lucide-react';

interface WidgetWrapperProps {
  id: string;
  editMode: boolean;
  onRemove: (id: string) => void;
  onReplace: (id: string) => void;
  onDragStart: (id: string) => void;
  onDragOver: (e: React.DragEvent, id: string) => void;
  onDrop: (e: React.DragEvent, id: string) => void;
  children: React.ReactNode;
}

const WidgetWrapper: React.FC<WidgetWrapperProps> = ({
  id,
  editMode,
  onRemove,
  onReplace,
  onDragStart,
  onDragOver,
  onDrop,
  children,
}) => {
  return (
    <div
      className={`relative rounded-lg overflow-hidden ${
        editMode ? 'ring-1 ring-rs-jet-light' : ''
      }`}
      draggable={editMode}
      onDragStart={() => onDragStart(id)}
      onDragOver={(e) => { e.preventDefault(); onDragOver(e, id); }}
      onDrop={(e) => onDrop(e, id)}
    >
      {editMode && (
        <div className="absolute top-2 right-2 flex items-center gap-1.5 z-20">
          <button
            className="p-1.5 rounded-full bg-rs-jet border border-rs-jet-light text-rs-off-white/70 hover:text-rs-off-white hover:bg-rs-jet-light transition-colors shadow-lg"
            title="Drag to reorder"
            onMouseDown={(e) => e.stopPropagation()}
          >
            <Move size={14} />
          </button>
          <button
            onClick={() => onReplace(id)}
            className="p-1.5 rounded-full bg-rs-jet border border-rs-jet-light text-rs-purple hover:bg-rs-jet-light transition-colors shadow-lg"
            title="Replace widget"
          >
            <Replace size={14} />
          </button>
          <button
            onClick={() => onRemove(id)}
            className="p-1.5 rounded-full bg-rs-jet border border-rs-jet-light text-rs-red hover:bg-rs-jet-light transition-colors shadow-lg"
            title="Remove widget"
          >
            <X size={14} />
          </button>
        </div>
      )}
      <div className={editMode ? 'opacity-90 pointer-events-none select-none' : ''}>
        {children}
      </div>
    </div>
  );
};

export default WidgetWrapper;
